import 'core-js/stable'
import '@babel/polyfill'
import './polyfills'
import 'regenerator-runtime'
import 'whatwg-fetch'
// @ts-ignore
import bootstrap from './bootstrap'

bootstrap(() => {})
